import { logUsage } from 'owa-analytics';
import { action } from 'satcheljs/lib/legacy';
import { getStore } from '../store/store';
import { GetStartedTaskStoreState } from '../store/schema/GetStartedTaskStoreState';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { GetStartedListPosition } from '../enums/GetStartedListPosition';

export default action('clickGetStartedTask')(async function clickGetStartedTask(
    identity: GetStartedTaskId,
    position: GetStartedListPosition
) {
    const store = getStore();
    let task: GetStartedTaskStoreState = store.tasks[identity];
    logUsage('GetStartedTaskClicked', [identity, position], { isCore: true });
    task.clicked = true;
});
